import { render } from "./Wheel.vue?vue&type=template&id=5b509efb"
import script from "./Wheel.vue?vue&type=script&lang=js"
export * from "./Wheel.vue?vue&type=script&lang=js"
script.render = render

export default script